import {AbstractProductSlide} from "./abstract-product-slide";

export default class FocusProductSlide extends AbstractProductSlide
{
    create(): any {
        let $pintrest = this.$element.find('.js-product-slides__slide-pin');
        let $wishlist = this.$element.find('.alg-wc-wl-btn');
        let $target = this.$element.find('.js-product-slides__slide-info');
        let $callToAction = $target.find('.js-product-slides__call-to-action');
        let contractedHeight = this.getContractedHeight($target);
        $wishlist
            .addClass('alg-wc-wl-btn--active')
            .css('opacity', 0);
        $pintrest
            .removeAttr('hidden')
            .css('opacity', 0);
        $callToAction
            .removeAttr('hidden')
            .css('opacity', 0);
        let expandedHeight = this.getExpandedHeight($target);
        $target
            .css('overflow', 'hidden')
            .css('height', contractedHeight)
        return this
            .timeline
            .to($target, 0.3, { height: expandedHeight, ease: 'power3.easeIn' })
            .to($target, 0.2, { backgroundColor: '#FFFFFF', ease: 'sine.easeOut' }, 0.1)
            .to($callToAction.add($pintrest).add($wishlist), 0.2, { opacity: 1, ease: 'sine.easeOut' }, 0.1)
        ;
    }
}